import React from 'react';
import ServerImage from './ServerImage';

const AboutTraining = () => {
  const trainingImages = [
    {
      id: 1,
      src: '/about/tr1.webp',
      alt: 'Training Session 1'
    },
    {
      id: 2,
      src: '/about/tr2.webp',
      alt: 'Training Session 2'
    },
    {
      id: 3,
      src: '/about/tr3.webp',
      alt: 'Training Certificate 1'
    },
    {
      id: 4,
      src: '/about/tr4.webp',
      alt: 'Training Certificate 2'
    }
  ];

  return (
    <section className="py-4 md:py-20 px-4 max-w-7xl mx-auto">
      {/* Header */}
      <div className="text-left md:text-center mb-2 md:mb-16">
        <h2 className="text-2xl lg:text-4xl font-bold text-gray-900 mb-1 md:mb-8">
          International Training & Business Consulting
        </h2>
        <p className="text-base md:text-lg  text-black max-w-4xl mx-auto leading-relaxed">
          Certified international trainer, delivering programs across teams and organizations with a focus on real-world impact, performance, and transformation.
        </p>
      </div>

      {/* Images Grid */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 md:gap-6">
        {trainingImages.map((image) => (
          <div key={image.id} className="group">
            <div className="relative overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 group-hover:-translate-y-2">
              <img
                src={image.src}
                alt={image.alt}
                fallback="/about/tr1.webp"
                className="w-full h-58 object-cover transition-transform duration-300 group-hover:scale-105"
              />
              
              {/* Overlay on hover */}
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300"></div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AboutTraining;